import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// sflanjie  是否拦截
// leibie 路由归类

export default new Router({
    routes: [{
            path: "/payGateWay",
            name: "payGateWay",
            component: () =>
                import ("@/views/payyemian/payGateWay"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/test_yst",
            name: "test_yst",
            component: () =>
                import ("@/views/test_yst"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/error",
            name: "error",
            component: () =>
                import ("@/views/error")
        },
        {
            path: "/upload",
            name: "upload",
            component: () =>
                import ("@/views/tongyong/upload"),
            // payyemian
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/payok",
            name: "payok",
            component: () =>
                import ("@/views/payyemian/payok"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/wxguanzhu",
            name: "wxguanzhu",
            component: () =>
                import ("@/views/payyemian/wxguanzhu"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/wxbangding",
            name: "wxbangding",
            component: () =>
                import ("@/views/payyemian/wxbangding"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/qqbangding",
            name: "qqbangding",
            component: () =>
                import ("@/views/payyemian/qqbangding"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/qqkfbangding",
            name: "qqkfbangding",
            component: () =>
                import ("@/views/payyemian/qqkfbangding"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/pay",
            name: "pay",
            component: () =>
                import ("@/views/payyemian/pay"),
            meta: {
                sflanjie: false,
                title: "在线支付"
            }
        },
        // {
        //   path: "/chat",
        //   name: "chat",
        //   component: () => import("@/views/char/index.vue"),
        //   meta: {
        //     sflanjie: false
        //   }
        // },
        {
            path: "/",
            //这要写死了...应该显示第一个
            redirect: "/index"
                // redirect: "/danzhang"
        },
        {
            //先把/的去掉，不要默认首页
            path: "/index",
            component: () =>
                import ("@/views/shouye"),
            meta: {
                sflanjie: false,
                laiyuan: ""
            },
            children: [{
                    path: `/otherchanpin/:id`,
                    name: "otherchanpin",
                    component: () =>
                        import ("@/views/chanpin/danbujian/otherchanpin"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: `/otherchanpinjiage/:id`,
                    name: "otherchanpinjiage",
                    component: () =>
                        import ("@/views/chanpin/danbujian/otherchanpinjiage"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/danzhang",
                    name: "danzhang",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhang"),
                    meta: {
                        sflanjie: false
                    }
                },

                {
                    path: "/danzhangshuma",
                    name: "danzhangshuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhangshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/danzhanguv",
                    name: "danzhanguv",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhanguv"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/danzhang4heban",
                    name: "danzhang4heban",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhang4heban"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/baoJiaXiangQing",
                    name: "baoJiaXiangQing",
                    component: () =>
                        import ("@/views/chanpin/components/baoJiaXiangQing"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/fuzi",
                    name: "fuzi",
                    component: () =>
                        import ("@/views/chanpin/danbujian/fuzi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/shoutidai",
                    name: "shoutidai",
                    component: () =>
                        import ("@/views/chanpin/danbujian/shoutidai"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/shoutidaishuma",
                    name: "shoutidaishuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/shoutidaishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/fengtao",
                    name: "fengtao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/fengtao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/fengtaoshuma",
                    name: "fengtaoshuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/fengtaoshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    //就是彩印专门的不干胶
                    path: "/buganjiao",
                    name: "buganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/buganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    //专版不干胶
                    path: "/zbbuganjiao",
                    name: "zbbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/zbbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    //nb专版不干胶
                    path: "/nbbuganjiao",
                    name: "nbbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/nbbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    //合版不干胶
                    path: "/hbbuganjiao",
                    name: "hbbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/hbbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/newsmbuganjiao",
                    name: "newsmbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/newsmbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/caihe",
                    name: "caihe",
                    component: () =>
                        import ("@/views/chanpin/danbujian/caihe"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/waleng",
                    name: "waleng",
                    component: () =>
                        import ("@/views/chanpin/danbujian/waleng"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/dangandai",
                    name: "dangandai",
                    component: () =>
                        import ("@/views/chanpin/danbujian/dangandai"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/dangandaishuma",
                    name: "dangandaishuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/dangandaishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/baozhi",
                    name: "baozhi",
                    component: () =>
                        import ("@/views/chanpin/danbujian/baozhi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/diaopai",
                    name: "diaopai",
                    component: () =>
                        import ("@/views/chanpin/danbujian/diaopai"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/pvc",
                    name: "pvc",
                    component: () =>
                        import ("@/views/chanpin/danbujian/pvc"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mingpian",
                    name: "mingpian",
                    component: () =>
                        import ("@/views/chanpin/danbujian/mingpian"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mingpianshuma",
                    name: "mingpianshuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/mingpianshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/xinfeng",
                    name: "xinfeng",
                    component: () =>
                        import ("@/views/chanpin/danbujian/xinfeng"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/xinzhi",
                    name: "xinzhi",
                    component: () =>
                        import ("@/views/chanpin/danbujian/xinzhi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/xinzhishuma",
                    name: "xinzhishuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/xinzhishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/huace",
                    name: "huace",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuace"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/huaceuv",
                    name: "huaceuv",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceuv"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/huaceshuma",
                    name: "huaceshuma",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/huacejz",
                    name: "huacejz",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuacejz"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/huaceuvjz",
                    name: "huaceuvjz",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceuvjz"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/huaceshumajz",
                    name: "huaceshumajz",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceshumajz"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/taili",
                    name: "taili",
                    component: () =>
                        import ("@/views/chanpin/duobujian/taili"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/tailishuma",
                    name: "tailishuma",
                    component: () =>
                        import ("@/views/chanpin/duobujian/tailishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/guali",
                    name: "guali",
                    component: () =>
                        import ("@/views/chanpin/duobujian/guali"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/gualishuma",
                    name: "gualishuma",
                    component: () =>
                        import ("@/views/chanpin/duobujian/gualishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/cjdlb",
                    name: "cjdlb",
                    component: () =>
                        import ("@/views/chanpin/duobujian/cjdlb"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/duilian",
                    name: "duilian",
                    component: () =>
                        import ("@/views/chanpin/duobujian/duilian"),
                    meta: {
                        sflanjie: false
                    }
                }
            ]
        },
        {
            path: "/dingdanzhongxin",
            name: "dingdanzhongxin",
            component: () =>
                import ("@/views/dingdanzhongxin/dingdanzhongxin"),
            meta: {
                sflanjie: true
            },
            children: [{
                    path: "/dingdanList",
                    name: "dingdanList",
                    component: () =>
                        import ("@/views/dingdanzhongxin/dingdanList"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/shenqingfapiao",
                    name: "shenqingfapiao",
                    component: () =>
                        import ("@/views/dingdanzhongxin/shenqingfapiao"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/kaifapiao/:ids",
                    name: "kaifapiao",
                    component: () =>
                        import ("@/views/dingdanzhongxin/kaifapiao"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/kaipiaolishi",
                    name: "kaipiaolishi",
                    component: () =>
                        import ("@/views/dingdanzhongxin/kaipiaolishi"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/zhanghumx",
                    name: "zhanghumx",
                    component: () =>
                        import ("@/views/dingdanzhongxin/zhanghumx"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/fapiaotaitou",
                    name: "fapiaotaitou",
                    component: () =>
                        import ("@/views/dingdanzhongxin/fapiaotaitou"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/shouhuodizhi",
                    name: "shouhuodizhi",
                    component: () =>
                        import ("@/views/dingdanzhongxin/address"),
                    meta: {
                        sflanjie: true
                    }
                }
            ]
        },
        {
            path: "/dingdanzhongxin_pc",
            name: "dingdanzhongxin_pc",
            component: () =>
                import ("@/views/dingdanzhongxin_pc"),
            meta: {
                sflanjie: true
            },
            children: [{
                    path: "/dingdanliebiao_pc",
                    name: "dingdanliebiao_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/dingdanliebiao"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/ddxiangqing_pc",
                    name: "ddxiangqing_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/ddxiangqing"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/zhanghuchongzhi_pc",
                    name: "zhanghuchongzhi_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/zhanghuchongzhi"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/zhanghumingxi_pc",
                    name: "zhanghumingxi_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/zhanghumingxi"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/zhanghuchongzhi_pc",
                    name: "zhanghuchongzhi_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/zhanghuchongzhi"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/youhuiquan_pc",
                    name: "youhuiquan_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/youhuiquan"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/shenqingfapiao_pc",
                    name: "shenqingfapiao_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/shenqingfapiao"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/kaifapiao_pc",
                    name: "kaifapiao_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/newkaifapiao"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/fapiaoxiangqing_pc",
                    name: "fapiaoxiangqing_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/fapiaoxiangqing"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/kaipiaolishi_pc",
                    name: "kaipiaolishi_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/kaipiaolishi"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/fapiaotaitou_pc",
                    name: "fapiaotaitou_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/fapiaotaitou"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/user_pc",
                    name: "user_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/user"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/address_pc",
                    name: "address_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/address"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/piliangxiadan_pc",
                    name: "piliangxiadan_pc",
                    component: () =>
                        import ("@/views/dingdanzhongxin_pc/batchesxiadan"),
                    meta: {
                        sflanjie: true
                    }
                }
            ]
        },
        {
            path: "/lingquanzhongxin",
            name: "lingquanzhongxin",
            component: () =>
                import ("@/views/youhuiquan/lingquanzhongxin"),
            meta: {
                sflanjie: true
            }
        },
        {
            path: "/dingdan_help",
            name: "dingdan_help",
            component: () =>
                import ("@/views/dingdan_help/index"),
            meta: {
                sflanjie: true
            }
        },
        {
            path: "/zhifuhegeren",
            component: () =>
                import ("@/views/gerenzhongxin/zhifuhegeren"),
            meta: {
                sflanjie: true
            },
            children: [{
                    path: "/zhanghaozx",
                    name: "zhanghaozx",
                    component: () =>
                        import ("@/views/gerenzhongxin/zhanghaozx"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/xiugaimima",
                    name: "xiugaimima",
                    component: () =>
                        import ("@/views/gerenzhongxin/xiugaimima"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/genghuanPhone",
                    name: "genghuanPhone",
                    component: () =>
                        import ("@/views/gerenzhongxin/genghuanPhone"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/newPhone",
                    name: "newPhone",
                    component: () =>
                        import ("@/views/gerenzhongxin/newPhone"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/zhifu",
                    name: "zhifu",
                    component: () =>
                        import ("@/views/zhifuyemian/zhifu"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/zhifu_pc",
                    name: "zhifu_pc",
                    component: () =>
                        import ("@/views/zhifuyemian/newzhifu"),
                    meta: {
                        sflanjie: true
                    }
                },
                {
                    path: "/dingdanxiangq",
                    name: "dingdanxiangq",
                    component: () =>
                        import ("@/views/dingdanzhongxin/dingdanxiangq"),
                    meta: {
                        sflanjie: true
                    }
                }
            ]
        },
        {
            path: "/shoujiIndex",
            name: "shoujiIndex",
            component: () =>
                import ("@/views/weixin/shoujiIndex"),
            meta: {
                sflanjie: false
            },
            children: [{
                    path: "/shouye",
                    name: "首页",
                    component: () =>
                        import ("@/views/weixin/shouye"),
                    meta: {
                        sflanjie: false,
                        laiyuan: "wx"
                            // allowBack: false
                    }
                },
                {
                    path: "/wxdingdanzhongxin",
                    name: "wx订单中心",
                    redirect: "/wxdingdanzhongxin/alldingdan",
                    component: () =>
                        import ("@/views/weixin/wxdingdanzhongxin/index"),
                    meta: {
                        sflanjie: false
                    },
                    children: [{
                            path: "/wxdingdanzhongxin/daizhifu",
                            name: "wx待支付",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "daizhifu" }
                        },
                        {
                            path: "/wxdingdanzhongxin/shenheshibai",
                            name: "wx审核未通过",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "shenheweitongguo" }
                        },
                        {
                            path: "/wxdingdanzhongxin/alldingdan",
                            name: "wx全部订单",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            }
                        },
                        {
                            path: "/wxdingdanzhongxin/daishouhuo",
                            name: "wx待收货",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "yifahuo" }
                        },
                        {
                            path: "/wxdingdanzhongxin/daiqueren",
                            name: "wx待确认",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "yanggaoqueren" }
                        }
                    ]
                },
                {
                    path: "/gerenIndex",
                    name: "gerenIndex",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/gerenIndex"),
                    meta: {
                        sflanjie: true
                    }
                }
            ]
        },
        {
            path: "/wxdingdanzhongxin/querengao",
            name: "确认稿确认",
            component: () =>
                import ("@/views/weixin/wxdingdanzhongxin/querengao"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/fahuoview",
            name: "确认稿图片",
            component: () =>
                import ("@/views/weixin/wxdingdanzhongxin/fahuoview"),
            meta: {
                sflanjie: false
            }
        },

        {
            path: "/dizhilist",
            name: "地址列表",
            component: () =>
                import ("@/views/weixin/dizhi/dizhilist"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/newdizhilist",
            name: "新下单地址列表",
            component: () =>
                import ("@/views/weixin/dizhi/newdizhilist"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/dizhibianji",
            name: "地址编辑",
            component: () =>
                import ("@/views/weixin/dizhi/dizhibianji"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/newdizhibianji",
            name: "新下单地址编辑",
            component: () =>
                import ("@/views/weixin/dizhi/newdizhibianji"),
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/zizhubaojia",
            component: () =>
                import ("@/views/weixin/zizhubaojia"),
            meta: {
                sflanjie: false
            },
            children: [{
                    path: `/mobile/otherchanpin/:id`,
                    name: "mobileotherchanpin",
                    component: () =>
                        import ("@/views/chanpin/danbujian/otherchanpin"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: `/mobile/otherchanpinjiage/:id`,
                    name: "mobileotherchanpinjiage",
                    component: () =>
                        import ("@/views/chanpin/danbujian/otherchanpinjiage"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/danzhang",
                    name: "mobiledanzhang",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhang"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/danzhangshuma",
                    name: "mobiledanzhangshuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhangshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/danzhanguv",
                    name: "mobiledanzhanguv",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhanguv"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/danzhang4heban",
                    name: "mobiledanzhang4heban",
                    component: () =>
                        import ("@/views/chanpin/danbujian/danzhang4heban"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/baoJiaXiangQing",
                    name: "mobilebaoJiaXiangQing",
                    component: () =>
                        import ("@/views/chanpin/components/baoJiaXiangQing"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/fuzi",
                    name: "mobilefuzi",
                    component: () =>
                        import ("@/views/chanpin/danbujian/fuzi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/shoutidai",
                    name: "mobileshoutidai",
                    component: () =>
                        import ("@/views/chanpin/danbujian/shoutidai"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/shoutidaishuma",
                    name: "mobileshoutidaishuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/shoutidaishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/fengtao",
                    name: "mobilefengtao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/fengtao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/fengtaoshuma",
                    name: "mobilefengtaoshuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/fengtaoshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/buganjiao",
                    name: "mobilebuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/buganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/zbbuganjiao",
                    name: "mobilezbbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/zbbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/nbbuganjiao",
                    name: "mobilenbbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/nbbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/hbbuganjiao",
                    name: "mobilehbbuganjiao",
                    component: () =>
                        import ("@/views/chanpin/danbujian/hbbuganjiao"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/caihe",
                    name: "mobilecaihe",
                    component: () =>
                        import ("@/views/chanpin/danbujian/caihe"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/waleng",
                    name: "mobilewaleng",
                    component: () =>
                        import ("@/views/chanpin/danbujian/waleng"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/dangandai",
                    name: "mobiledangandai",
                    component: () =>
                        import ("@/views/chanpin/danbujian/dangandai"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/dangandaishuma",
                    name: "mobiledangandaishuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/dangandaishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/baozhi",
                    name: "mobilebaozhi",
                    component: () =>
                        import ("@/views/chanpin/danbujian/baozhi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/diaopai",
                    name: "mobilediaopai",
                    component: () =>
                        import ("@/views/chanpin/danbujian/diaopai"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/pvc",
                    name: "mobilepvc",
                    component: () =>
                        import ("@/views/chanpin/danbujian/pvc"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/mingpian",
                    name: "mobilemingpian",
                    component: () =>
                        import ("@/views/chanpin/danbujian/mingpian"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/mingpianshuma",
                    name: "mobilemingpianshuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/mingpianshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/xinfeng",
                    name: "mobilexinfeng",
                    component: () =>
                        import ("@/views/chanpin/danbujian/xinfeng"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/xinzhi",
                    name: "mobilexinzhi",
                    component: () =>
                        import ("@/views/chanpin/danbujian/xinzhi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/xinzhishuma",
                    name: "mobilexinzhishuma",
                    component: () =>
                        import ("@/views/chanpin/danbujian/xinzhishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/huace",
                    name: "mobilehuace",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuace"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/huaceshuma",
                    name: "mobilehuaceshuma",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceshuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/huacejz",
                    name: "mobilehuacejz",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuacejz"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/huaceshumajz",
                    name: "mobilehuaceshumajz",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceshumajz"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/huaceuv",
                    name: "mobilehuaceuv",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceuv"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/huaceuvjz",
                    name: "mobilehuaceuvjz",
                    component: () =>
                        import ("@/views/chanpin/duobujian/newhuaceuvjz"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/taili",
                    name: "mobiletaili",
                    component: () =>
                        import ("@/views/chanpin/duobujian/taili"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/tailishuma",
                    name: "mobiletailishuma",
                    component: () =>
                        import ("@/views/chanpin/duobujian/tailishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/guali",
                    name: "mobileguali",
                    component: () =>
                        import ("@/views/chanpin/duobujian/guali"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/gualishuma",
                    name: "mobilegualishuma",
                    component: () =>
                        import ("@/views/chanpin/duobujian/gualishuma"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/cjdlb",
                    name: "mobilecjdlb",
                    component: () =>
                        import ("@/views/chanpin/duobujian/cjdlb"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/mobile/duilian",
                    name: "mobileduilian",
                    component: () =>
                        import ("@/views/chanpin/duobujian/duilian"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/zizhubaojia/dingdanzhifu",
                    name: "订单支付",
                    component: () =>
                        import ("@/views/weixin/xiadanzhifu/index"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/zizhubaojia/zhifu_wx",
                    name: "移动端支付",
                    component: () =>
                        import ("@/views/weixin/xiadanzhifu/wxzhifu"),
                    meta: {
                        sflanjie: false
                    }
                }
            ]
        },
        {
            path: "/gerenzhongxin/component",
            name: "component",
            component: () =>
                import ("@/views/weixin/gerenzhongxin/component"),
            meta: {
                sflanjie: false
            },
            children: [{
                    path: "/gerenzhongxin/chongzhi",
                    name: "充值",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/chongzhi"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/gerenzhongxin/newchongzhi_wx",
                    name: "充值中心",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/newchongzhi_wx"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/gerenzhongxin/bindphone",
                    name: "绑定手机",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/bindphone")
                },
                {
                    path: "/gerenzhongxin/huankuan",
                    name: "还款",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/huankuan"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/gerenzhongxin/kaipiaoinfo",
                    name: "开票信息",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/kaipiaoinfo"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/gerenzhongxin/lingquanzhongxin",
                    name: "领券中心",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/lingquanzhongxin"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/gerenzhongxin/youhuiquan",
                    name: "我的优惠卷",
                    component: () =>
                        import ("@/views/weixin/gerenzhongxin/youhuiquan"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/wxdingdanzhongxin/dingdanxiangqing",
                    name: "订单详情",
                    component: () =>
                        import ("@/views/weixin/wxdingdanzhongxin/dingdanxiangqing"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/qqdingdanzhongxin/ddjindu",
                    name: "订单 进度",
                    component: () =>
                        import ("@/views/weixin/wxdingdanzhongxin/ddjindu"),
                    meta: {
                        sflanjie: false
                    }
                },
                {
                    path: "/wxdingdanzhongxin/ddjindu",
                    name: "订单进度",
                    component: () =>
                        import ("@/views/weixin/wxdingdanzhongxin/ddjindu"),
                    meta: {
                        sflanjie: false
                    }
                }
            ]
        },
        {
            path: "/qidianqqB/zizhuxiadan",
            name: "自助下单",
            component: () =>
                import ("@/views/weixin/shouye"),
            meta: {
                sflanjie: false,
                laiyuan: "wx"
            },
            meta: {
                sflanjie: false
            }
        },
        {
            path: "/qidianqqB",
            name: "起点QQ b端",
            redirect: "/qidianqqB/huiyuanxinxi",
            component: () =>
                import ("@/views/qidianqqB/shouyeindex"),
            children: [{
                    path: "/qidianqqB/huiyuanxinxi",
                    name: "会员信息",
                    component: () =>
                        import ("@/views/qidianqqB/huiyuanxinxi")
                },
                {
                    path: "/qidianqqB/dingdaninfo",
                    name: "订单详细",
                    component: () =>
                        import ("@/views/qidianqqB/dingdaninfo")
                },
                {
                    path: "/qidianqqB/titaxiadan",
                    name: "会员信息-替他下单",
                    component: () =>
                        import ("@/views/qidianqqB/titaxiadan")
                },
                {
                    path: "/qqquanbudingdan",
                    name: "qq订单中心",
                    redirect: "/qqdingdanzhongxin/daizhifu",
                    component: () =>
                        import ("@/views/qidianqqB/quanbudingdan"),
                    meta: {
                        sflanjie: false
                    },
                    children: [{
                            path: "/qqdingdanzhongxin/daizhifu",
                            name: "全部订单",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "daizhifu" }
                        },
                        {
                            path: "/qqdingdanzhongxin/shenheshibai",
                            name: "B审核未通过",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "shenheweitongguo" }
                        },
                        {
                            path: "/qqdingdanzhongxin/alldingdan",
                            name: "B全部订单",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            }
                        },
                        {
                            path: "/qqdingdanzhongxin/daishouhuo",
                            name: "B待收货",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "yifahuo" }
                        },
                        {
                            path: "/qqdingdanzhongxin/daiqueren",
                            name: "B待确认",
                            component: () =>
                                import ("@/views/weixin/wxdingdanzhongxin/alldingdan"),
                            meta: {
                                sflanjie: false
                            },
                            props: { zt: "yanggaoqueren" }
                        }
                    ]
                }
            ]
        },
        {
            path: "/baojiapc/querengao",
            name: "确认稿",
            component: () =>
                import ("@/views/dingdanzhongxin/confirm")
        },
        {
            path: "/confirm",
            name: "确认稿",
            component: () =>
                import ("@/views/dingdanzhongxin/confirm")
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js